import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getObservableFromAsyncValueSafe } from '../../../../models/async-value';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { FieldLabelConfig } from '../../models/field-configs/field-label-config.interface';
import { DEFAULT_ADDRESS_VALUE } from '../../../../../order-builder/modules/location/constants/default-address-value.constants';

@Component({
  selector: 'app-form-generic-item',
  templateUrl: './form-generic-item.component.html',
  styleUrls: ['./form-generic-item.component.scss'],
})
export class FormGenericItemComponent extends AbstractField implements OnInit, OnDestroy {
  // Config
  public config: FieldLabelConfig;
  private ngDestroy = new Subject();

  // View
  public text: string;
  public visible = true;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.config.text) {
      getObservableFromAsyncValueSafe(this.config.text)
        .pipe(takeUntil(this.ngDestroy))
        .subscribe((text) => {
          if (!!text) {
            this.text = text.replace(DEFAULT_ADDRESS_VALUE, '');
          }
        });
    } else if (this.getControl() && this.getControl().value) {
      this.text = this.getControl().value.toString();
    }
    if (this.config.visible !== undefined) {
      getObservableFromAsyncValueSafe(this.config.visible)
        .pipe(takeUntil(this.ngDestroy))
        .subscribe((fieldVisibility) => (this.visible = fieldVisibility));
    }
    if (this.config.containerClassNamesFn) {
      getObservableFromAsyncValueSafe(this.config.containerClassNamesFn)
        .pipe(takeUntil(this.ngDestroy))
        .subscribe((classNames) => (this.config.containerClassNames = classNames));
    }
  }

  public ngOnDestroy(): void {
    this.ngDestroy.next();
    this.ngDestroy.complete();
  }
}
